
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookinginpuneforoutstation() {



    const cardData =
    {
        keyword: 'Cab Booking in Pune for Outstation',
        heading: 'Platinum24 Cabs: Cab Booking in Pune for Outstation',
        headingDescription: ' Platinum24 Cabs offers hassle-free Cab Booking in Pune for Outstation, making your long-distance journeys comfortable and reliable. Our wide fleet of hatchbacks, sedans, SUVs, and luxury cars ensures the perfect travel option for families, corporate groups, and solo travelers. With experienced chauffeurs, on-time pickups, and 24/7 availability, we guarantee safe and stress-free outstation trips to popular destinations like Mumbai, Shirdi, Mahabaleshwar, Lonavala, Goa, and beyond. Platinum24 Cabs provides affordable fares, transparent pricing, and flexible booking options, ensuring your outstation travel from Pune is smooth, comfortable, and enjoyable.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, it showcases grand gateways, fountains, and gardens. Though partially destroyed by fire in 1828, its ruins still narrate tales of Bajirao and Mastani. The evening light-and-sound show recreates Maratha history. Tourists love exploring its majestic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument with Italian arches and sprawling gardens. It is historically significant as Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. The palace houses a museum displaying Gandhi’s personal items and photographs. Its calm ambiance attracts history and peace seekers. The palace is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon adds mist and waterfalls, enhancing its beauty. Local villagers serve rustic delicacies like pithla-bhakri at the top. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and ornaments, attracting devotees year-round. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable and cultural initiatives. The vibrant spiritual aura makes it a must-visit. Dagdusheth Temple is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. It features rock-cut architecture with massive stone pillars, a sanctum, and a Nandi mandapa. Located in the city center, it offers a peaceful retreat from urban life. Evening prayers and chants create a mystical ambiance. Its ancient carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and daily-use antiques. The recreated Mastani Mahal is the highlight for visitors. History lovers and students find it fascinating and educational. The museum preserves centuries of Indian culture and traditions. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. The site also houses smaller shrines and a museum. Sunrise and sunset views are mesmerizing from here. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from around the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls add to its charm. Visitors experience rejuvenation and mindfulness here. Osho Ashram is Pune’s international wellness destination."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy peaceful walks, photography, and picnics here. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green oasis of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. Monsoon transforms it into a picturesque spot with overflowing streams. Street vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],



      "services": [
    {
      "name": "Cab Booking Pune Outstation",
      "description": "Plan your outstation travel from Pune effortlessly with our cab booking services. Whether you're heading to a nearby hill station, a pilgrimage site, or a long-distance destination, we provide reliable, clean, and comfortable vehicles driven by professional chauffeurs. Our service includes multiple vehicle options, real-time booking updates, and 24/7 customer support, ensuring peace of mind for travelers of all kinds."
    },
    {
      "name": "Outstation Cab Booking Pune",
      "description": "Book outstation cabs from Pune for one-way, round-trip, or multi-city travel. With a wide network of partner vehicles, we guarantee availability even during weekends or peak seasons. Choose from budget hatchbacks to premium sedans and SUVs depending on your group size and travel needs. Flexible plans and doorstep pickup options are included."
    },
    {
      "name": "Pune Outstation Taxi Booking Online",
      "description": "Reserve your outstation taxi online from Pune within minutes. Our platform offers an easy interface for checking cab availability, comparing fares, selecting vehicles, and confirming your ride. Perfect for business travel, leisure trips, or family holidays, with real-time tracking and instant confirmation on booking."
    },
    {
      "name": "Pune Outstation Cab Hire",
      "description": "Hire an outstation cab from Pune with flexible packages including hourly, daily, or customized plans. Enjoy the convenience of sanitized vehicles, verified drivers, and transparent pricing. We cover popular outstation routes like Mumbai, Goa, Mahabaleshwar, Shirdi, and more."
    },
    {
      "name": "Outstation Car Booking Pune",
      "description": "Book a car for outstation travel from Pune with full assurance of safety, affordability, and timely service. We provide both chauffeur-driven and self-drive options with flexible rental durations. Every car is GPS-enabled, well-maintained, and suited for long journeys."
    },
    {
      "name": "Best Outstation Taxi Booking Pune",
      "description": "Get access to the best outstation taxi booking options in Pune, offering a blend of comfort, safety, and affordability. Our fleet is composed of new-generation vehicles with AC, luggage space, and driver support for your round-trip or one-way needs. Rated highly by thousands of satisfied travelers."
    },
    {
      "name": "Affordable Outstation Taxi Pune",
      "description": "Looking for low-cost outstation taxis from Pune? We’ve got you covered with economy rides, discounts on early bookings, and customized fare plans. Ideal for weekend trips, solo journeys, and group tours, all at unbeatable prices with no hidden charges."
    },
    {
      "name": "Pune Outstation Taxi with Driver Booking",
      "description": "Book an outstation taxi from Pune complete with a courteous and trained driver. Our drivers are route-experienced and focused on your safety and comfort. Whether it’s a temple tour or a beach getaway, you get a hassle-free experience from pickup to drop."
    },
    {
      "name": "Pune Outstation Cab Booking Deals",
      "description": "Avail special deals on outstation cab bookings from Pune. Offers include discounts for early bookings, weekend packages, round-trip combos, and festival specials. Ideal for travelers looking to save while enjoying a premium ride experience."
    },
    {
      "name": "Online Cab Booking Outstation Pune",
      "description": "Book your outstation cab online from Pune with just a few clicks. Our platform ensures transparent billing, real-time driver allocation, and easy modifications or cancellations. Available for all major outstation destinations across Maharashtra and beyond."
    },
    {
      "name": "Pune Outstation Cab Packages",
      "description": "Explore our specially curated outstation cab packages from Pune. Whether it's a 2-day religious tour or a 5-day hill station vacation, we offer fixed itinerary pricing, including fuel, tolls, and driver allowance. Great for family vacations and planned trips."
    },
    {
      "name": "Pune Outstation Taxi Fare Booking",
      "description": "Get full details and fare breakups before booking your outstation taxi from Pune. Know what you’re paying for—vehicle type, distance, taxes, and inclusions. Fare comparison options are also available to help you choose the best deal."
    },
    {
      "name": "Outstation Taxi Service Pune Booking",
      "description": "Our outstation taxi services in Pune are trusted by thousands for safe, punctual, and comfortable intercity travel. Available 24/7, our services cater to last-minute plans, business meetings out of town, and multi-city tours with ease."
    },
    {
      "name": "Pune Outstation Cab Booking App",
      "description": "Download our Pune outstation cab booking app to manage all your travel needs on the go. Features include live fare estimates, instant ride confirmations, cab tracking, and customer support. The app is lightweight and user-friendly for quick bookings."
    },
    {
      "name": "Pune Outstation Luxury Cab Booking",
      "description": "Book a luxury outstation cab from Pune for a premium travel experience. Our fleet includes Mercedes, BMW, Audi, and premium SUVs for executives, VIPs, and special occasions. These rides come with professional chauffeurs, extra legroom, and high-end features."
    }
  ],
  "tableData": [
    ["Cab Booking Pune Outstation", "Outstation Cab Booking Pune"],
    ["Pune Outstation Taxi Booking Online", "Pune Outstation Cab Hire"],
    ["Outstation Car Booking Pune", "Best Outstation Taxi Booking Pune"],
    ["Affordable Outstation Taxi Pune", "Pune Outstation Taxi with Driver Booking"],
    ["Pune Outstation Cab Booking Deals", "Online Cab Booking Outstation Pune"],
    ["Pune Outstation Cab Packages", "Pune Outstation Taxi Fare Booking"],
    ["Outstation Taxi Service Pune Booking", "Pune Outstation Cab Booking App"],
    ["Pune Outstation Luxury Cab Booking", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Easy Cab Booking in Pune for Outstation Trips",
      "WhyChoosedescription": "Platinum24 Cabs offers seamless and quick cab booking for outstation travel from Pune to any destination."
    },
    {
      "WhyChooseheading": "Reliable and Comfortable Long-Distance Travel",
      "WhyChoosedescription": "Enjoy stress-free journeys in clean, air-conditioned, and well-maintained vehicles."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Route Knowledge",
      "WhyChoosedescription": "Our trained drivers ensure safe, efficient, and timely travel on all outstation routes."
    },
    {
      "WhyChooseheading": "Flexible Booking Options: One-Way or Round Trip",
      "WhyChoosedescription": "Choose from customizable packages that fit your schedule and trip duration."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Get upfront fares inclusive of fuel, tolls, and driver charges—no last-minute surprises."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
      "WhyChoosedescription": "Our support team is available round the clock to help you with bookings, changes, and inquiries."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options for Every Travel Need",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers based on your group size and comfort."
    },
    {
      "WhyChooseheading": "Perfect for Family Vacations, Pilgrimages & Business Travel",
      "WhyChoosedescription": "Our outstation cab services from Pune are ideal for all kinds of travel requirements."
    }
  ]






































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer outstation cab booking services from Pune?',
        answer: 'Yes, Platinum24 Cabs provides convenient and affordable cab booking services in Pune for all outstation destinations.',
    },
    {
        question: 'How do I book an outstation cab from Pune with Platinum24 Cabs?',
        answer: 'You can book an outstation cab through our website, mobile app, or by calling our customer support for assistance.',
    },
    {
        question: 'What vehicle options are available for outstation cab booking from Pune?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, tempo travellers, and luxury cars for your outstation trips.',
    },
    {
        question: 'Are your outstation cab services available 24/7 in Pune?',
        answer: 'Yes, we operate 24/7 to ensure you can book a cab for any outstation journey at your preferred time.',
    },
    {
        question: 'Is it possible to book a round trip outstation cab from Pune?',
        answer: 'Absolutely! We offer both one-way and round-trip cab packages with flexible schedules and transparent pricing.',
    },
    {
        question: 'What’s included in the fare for outstation cabs from Pune?',
        answer: 'Our fares typically include vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for waiting time or detours.',
    },
    {
        question: 'Can I book a multi-day outstation cab from Pune?',
        answer: 'Yes, we provide customizable multi-day travel packages for extended trips to various outstation destinations.',
    },
    {
        question: 'Are the drivers experienced with outstation routes from Pune?',
        answer: 'Yes, our drivers are experienced, professional, and well-versed with major outstation routes from Pune.',
    },
    {
        question: 'Do you provide safety and hygiene assurance during outstation trips?',
        answer: 'All our vehicles are sanitized regularly and drivers adhere to strict safety and hygiene protocols.',
    },
    {
        question: 'Does Platinum24 Cabs offer corporate outstation travel services from Pune?',
        answer: 'Yes, we offer special corporate packages with flexible billing, priority support, and well-maintained vehicles for business travel needs.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Nitin Pawar',
        feedback: 'Booked an outstation cab from Pune with Platinum24 Cabs. The service was smooth, driver was courteous, and the car was in great condition.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Swati Joshi',
        feedback: 'We regularly use Platinum24 for our outstation trips. Always on time, professional drivers, and clean vehicles. Highly recommended!',
        rating: 5,
    },
];















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const cabBookingPuneOutstationSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Booking in Pune for Outstation",
  "provider": {
    "@type": "Organization",
    "name": "Platinum24 Cabs",
    "url": "https://www.platinum24cab.com"
  },
  "serviceType": "Outstation Cab Booking",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "description": "Book reliable and affordable outstation cabs from Pune with Platinum24 Cabs. Easy online booking for outstation taxi services with professional drivers and competitive fares.",
  "url": "https://www.platinum24cab.com/cab-booking-pune-outstation"
};







    return (
        <div>

<Helmet>
  <title>Cab Booking in Pune for Outstation | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable and affordable outstation cabs from Pune with Platinum24 Cabs. Easy online booking for outstation taxi services with professional drivers and competitive fares."
  />
  <meta
    name="keywords"
    content="Cab Booking Pune Outstation, Outstation Cab Booking Pune, Pune Outstation Taxi Booking Online, Pune Outstation Cab Hire, Outstation Car Booking Pune, Best Outstation Taxi Booking Pune, Affordable Outstation Taxi Pune, Pune Outstation Taxi with Driver Booking, Pune Outstation Cab Booking Deals, Online Cab Booking Outstation Pune, Pune Outstation Cab Packages, Pune Outstation Taxi Fare Booking, Outstation Taxi Service Pune Booking, Pune Outstation Cab Booking App, Pune Outstation Luxury Cab Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(cabBookingPuneOutstationSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabbookinginpuneforoutstation;